export default function getCustomYear(date = new Date()) {
    const year = date.getFullYear();
    const cutoffMonth = 9;
    const cutoffDay = 1;
  
    const cutoffDate = new Date(year, cutoffMonth, cutoffDay);
  
    return date < cutoffDate ? year : year + 1;
  }